import { Map } from 'immutable';

export function clearAdditional(state) {
    return Map({
        global: state.get('global')
    });
}
